// TODO: Remove this file when proxying from (dev.|qa.|stage.)mytech.ge.com/portal is no longer needed
/**
 * Temporary prefix needed for stage.mytech.ge.com/portal to serve stage app
 * and mytech.ge.com/portal to serve production app.
 * stage.mytech.ge.com/portal will proxy http://example.com
 * mytech.ge.com/portal will proxy http://example.com
 */
// TODO: move proxyHostNames to env vars
const proxyHostNames = [
  'https://dev.example.com',
  'https://qa.example.com',
  'https://stage.example.com',
  'https://example.com',
];

export const proxyPrefix = '/portal';
export const isProxied = () => {
  return proxyHostNames.indexOf(window.location.origin) !== -1;
};
